import SuperAdminDashboard from "../Pages/SSSAuto/SuperAdmin/dashboard/Dashboard";
import AddUser from "../Pages/SSSAuto/SuperAdmin/users/add-user/AddUser";
import AddDevice from "../Pages/SSSAuto/SuperAdmin/devices/AddDevice";
import AddReason from "../Pages/SSSAuto/HoldReason/AddReason";
import AddBayLocation from "../Pages/SSSAuto/BinBayLocation/AddBayLocation";
import AddFakeCustomer from "../Pages/SSSAuto/FakeCustomer/AddFakeCustomer";
import AddCustomNotification from "../Pages/SSSAuto/CustomNotification/AddCustomNotification";
import ResyncOrder from "../Pages/SSSAuto/ResyncOrder";
import RemoteBay from "../Pages/SSSAuto/RemoteBay";
import AddRemoteBay from "../Pages/SSSAuto/RemoteBay/AddRemoteBay";
import AddDriver from "../Pages/SSSAuto/Delivery/Drivers/AddDriver";
import AddDepot from "../Pages/SSSAuto/Delivery/Depot/AddDepot";
import TrackOrder from "../Pages/SSSAuto/Delivery/TrackOrder";
import AddDeliveryReason from "../Pages/SSSAuto/Delivery/Reasons/AddReason";
import AddRegionalFreight from "../Pages/SSSAuto/RegionalFreight/AddRegionalFreight";

export const staticRoutes = [
  {
    path: "/",
    component: SuperAdminDashboard,
    exact: true,
  },
  {
    path: "/users/add",
    component: AddUser,
  },
  {
    path: "/users/edit/:id",
    component: AddUser,
  },
  {
    path: "/devices/add",
    component: AddDevice,
  },
  {
    path: "/devices/edit/:id",
    component: AddDevice,
  },
  {
    path: "/hold-reason/add",
    component: AddReason,
  },
  {
    path: "/hold-reason/edit/:id",
    component: AddReason,
  },
  {
    path: "/bin-bay-location/edit/:id",
    component: AddBayLocation,
  },
  {
    path: "/fake-customer/add",
    component: AddFakeCustomer,
  },
  {
    path: "/custom-notifications/add",
    component: AddCustomNotification,
  },
  {
    path: "/custom-notifications/edit/:id",
    component: AddCustomNotification,
  },
  {
    path: "/regional-freight/add",
    component: AddRegionalFreight,
  },
  {
    path: "/fetch-order",
    component: ResyncOrder,
  },
  {
    path: "/remote-bay",
    component: RemoteBay,
  },
  {
    path: "/remote-bay/add",
    component: AddRemoteBay,
  },
  {
    path: "/delivery/drivers/add",
    component: AddDriver,
  },
  {
    path: "/delivery/drivers/edit/:id",
    component: AddDriver,
  },
  {
    path: "/delivery/orders/track-order",
    component: TrackOrder,
  },
  {
    path: "/delivery/reasons/add",
    component: AddDeliveryReason,
  },
  {
    path: "/delivery/reasons/edit/:id",
    component: AddDeliveryReason,
  },
  {
    path: "/delivery/depot/add",
    component: AddDepot,
  },
  {
    path: "/delivery/depot/edit/:id",
    component: AddDepot,
  },
];
